import { NotifyHelper } from "../../../helpers/toast";
import { ePageBaseStatus } from "../../../models/ePageBaseStatus";
import { eNgayNghiActionTypeIds, INgayNghiActionTypes } from "../../action-types/danh-muc/INgayNghiActionTypes";
import { INgayNghiPageState } from "../../page-state-model/danh-muc/INgayNghiPageState";

const initialState: INgayNghiPageState = {
    status: ePageBaseStatus.is_not_initialization,
    ngayNghis: [],
    editingData: undefined,
    isShowEditModal: false,
};

export const ngayNghiReducer = (state: INgayNghiPageState = initialState, action: INgayNghiActionTypes): INgayNghiPageState => {
    switch (action.type) {
        case eNgayNghiActionTypeIds.LOAD_START:
            return {
                ...state,
                status: ePageBaseStatus.is_loading,
            };
        case eNgayNghiActionTypeIds.LOAD_SUCCESS:
            return {
                ...state,
                status: ePageBaseStatus.is_completed,
                ngayNghis: action.payload,
            };
        case eNgayNghiActionTypeIds.LOAD_ERROR:
            NotifyHelper.Error(action.payload);
            return {
                ...state,
                status: ePageBaseStatus.is_completed,
                ngayNghis: [],
            };

        case eNgayNghiActionTypeIds.SAVE_START:
            return {
                ...state,
                status: ePageBaseStatus.is_saving,
            };
        case eNgayNghiActionTypeIds.SAVE_SUCCESS:
            NotifyHelper.Success("Lưu dữ liệu thành công.");
            return {
                ...state,
                status: ePageBaseStatus.is_need_reload,
                isShowEditModal: false,
                editingData: undefined,
            };
        case eNgayNghiActionTypeIds.SAVE_ERROR:
            NotifyHelper.Error(action.payload);
            return {
                ...state,
                status: ePageBaseStatus.is_completed,
            };

        case eNgayNghiActionTypeIds.DELETE_START:
            return {
                ...state,
                status: ePageBaseStatus.is_deleting,
            };
        case eNgayNghiActionTypeIds.DELETE_SUCCESS:
            NotifyHelper.Success("Xoá dữ liệu thành công.");
            return {
                ...state,
                status: ePageBaseStatus.is_need_reload,
            };
        case eNgayNghiActionTypeIds.DELETE_ERROR:
            NotifyHelper.Error(action.payload);
            return {
                ...state,
                status: ePageBaseStatus.is_completed,
            };

        case eNgayNghiActionTypeIds.SHOW_EDIT_MODAL:
            return {
                ...state,
                isShowEditModal: true,
                editingData: action.payload,
            };
        case eNgayNghiActionTypeIds.CLOSE_EDIT_MODAL:
            return {
                ...state,
                isShowEditModal: false,
                editingData: undefined,
            };

        default:
            return state;
    }
};
